/**
 * Telemetry master switch. Off until there is a consent UI: while false the
 * app creates no player ID and sends nothing to /players or /events. The
 * consent PR turns this on and calls IdentityService.register() and
 * TelemetryService.setEnabled(true) only for players who opt in.
 */
export const TELEMETRY_ENABLED = false;
